import { createBrowserRouter, Navigate } from "react-router-dom";
import ErrorPage from "./error-page";
import { PrivateRoute, PublicRoute } from "./route-guard";
import ProductInstance from "../pages/Products/instances/ProductInstance";
import EditProductInstance from "../pages/EditProduct";
import CategoryInstance from "../pages/Categories/instances/CategoryInstance";
import AddCategoryInstance from "../pages/AddCategory/instances/AddCategoryInstance";
import EditCategoryInstance from "../pages/EditCategory/instances/EditCategoryInstance";
import { Login } from "../pages/Login";
import { FogotPassword } from "../pages/FogotPassword";
import { ResetPassword } from "../pages/ResetPassword";
import AddProductInstance from "../pages/AddProduct/instances/AddProductnstance";
import { MainLayout } from "../components/layout/MainLayout";
import BrandInstance from "../pages/Brands/instances/BrandInstance";
import AddBrandInstance from "../pages/AddBrand/instances/AddBrandInstance";
import EditBrandInstance from "../pages/EditBrand/instances/EditBrandInstance";
import UserInstance from "../pages/Users/instances/UserInstance";
import OrderInstance from "../pages/OrderManage/instances/OrderInstance";
import OrderDetailsInstance from "../pages/OrderDetails/instances/OrderDetailsInstance";
import AddUserInstance from "../pages/addUser/instances/AddUserInstance";
import AddBannerInstance from "../pages/AddBanners/instances/AddBannerInstance";
import OfferInstance from "../pages/Offers/instances/OfferInstance";
import AddOfferInstance from "../pages/AddOffers/instances/AddOfferInstance";
import TagsInstance from "../pages/Tags/instances/TagsInstance";
import AdminInstance from "../pages/Admin/instances/AdminInstance";
import AddAdminInstance from "../pages/AddNewAdmin/instances/AddAdminInstance";
import MyProfile from "../pages/MyProfile/MyProfile";
import ArticleInstance from "../pages/Articles/instances/ProductInstance";
import AddArticleInstance from "../pages/AddArticle/instances/AddProductnstance";
// Define route constants
export const ROUTES = {
  HOME: "/",
  ARTICLES: "/articles",
  ADD_ARTICLE: "/articles/add-new-article",
  PRODUCTS: "/products",
  ADD_PRODUCT: "/products/add-new-product",
  ADD_BANNER: "/banners",
  EDIT_PRODUCT: "/products/edit/:productId",
  CATEGORIES: "/categories",
  ADD_CATEGORY: "/categories/add-new-category",
  EDIT_CATEGORY: "/categories/edit/:categoryId",
  BRANDS: "/brands",
  OFFERS: "/offers",
  TAGS:"/tags",
  ADD_OFFERS: "/offers/add-new-offer",
  USER: "/users",
  ADMINS: "/admins",
  MY_PROFILE: "/my-profile",
  ADDADMINS: "/admins/add-new-admin",
  ADD_USER: "/users/add-new-user",
  ADD_BRAND: "/brands/add-new-brand",
  EDIT_BRAND: "/brands/edit/:brandId",
  ORDERS: "/orders",
  ORDER_DETAIL: "/orders/:orderId",
  FORGOT_PASSWORD: "/auth/forgot-password",
  RESET_PASSWORD: "/auth/reset-password",
  LOGIN: "/auth/login",
};

export const router = createBrowserRouter([
  {
    path: ROUTES.HOME,
    element: (
      <PrivateRoute>
        <MainLayout hassidebar={true} hasHeader={true} />
      </PrivateRoute>
    ),
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Navigate to={ROUTES.PRODUCTS} replace />
      },
      {
        path: ROUTES.PRODUCTS,
        element: (
          <PrivateRoute>
            <ProductInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.ARTICLES,
        element: (
          <PrivateRoute>
            <ArticleInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.ADD_ARTICLE,
        element: (
          <PrivateRoute>
            <AddArticleInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.ADD_PRODUCT,
        element: (
          <PrivateRoute>
            <AddProductInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.OFFERS,
        element: (
          <PrivateRoute>
            <OfferInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.ADMINS,
        element: (
          <PrivateRoute>
            <AdminInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.MY_PROFILE,
        element: (
          <PrivateRoute>
            <MyProfile />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.ADDADMINS,
        element: (
          <PrivateRoute>
            <AddAdminInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.TAGS,
        element: (
          <PrivateRoute>
            <TagsInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.ADD_OFFERS,
        element: (
          <PrivateRoute>
            <AddOfferInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.ADD_BANNER,
        element: (
          <PrivateRoute>
            <AddBannerInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.EDIT_PRODUCT,
        element: (
          <PrivateRoute>
            <EditProductInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.CATEGORIES,
        element: (
          <PrivateRoute>
            <CategoryInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.ADD_CATEGORY,
        element: (
          <PrivateRoute>
            <AddCategoryInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.EDIT_CATEGORY,
        element: (
          <PrivateRoute>
            <EditCategoryInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.BRANDS,
        element: (
          <PrivateRoute>
            <BrandInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.USER,
        element: (
          <PrivateRoute>
            <UserInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.ADD_BRAND,
        element: (
          <PrivateRoute>
            <AddBrandInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.ADD_USER,
        element: (
          <PrivateRoute>
            <AddUserInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.EDIT_BRAND,
        element: (
          <PrivateRoute>
            <EditBrandInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.ORDERS,
        element: (
          <PrivateRoute>
            <OrderInstance />
          </PrivateRoute>
        ),
      },
      {
        path: ROUTES.ORDER_DETAIL,
        element: (
          <PrivateRoute>
            <OrderDetailsInstance />
          </PrivateRoute>
        ),
      },
    ],
  },
  {
    path: ROUTES.FORGOT_PASSWORD,
    element: (
      <PublicRoute>
        <FogotPassword />
      </PublicRoute>
    ),
  },
  {
    path: ROUTES.RESET_PASSWORD,
    element: (
      <PublicRoute>
        <ResetPassword />
      </PublicRoute>
    ),
  },
  {
    path: ROUTES.LOGIN,
    element: (
      <PublicRoute>
        <Login />
      </PublicRoute>
    ),
  },
]);
